const getCategoryFilterQuery = (queryString: string, categorieId: string) => {
  const params = new URLSearchParams(queryString)

  const b = params.get('b') || ''
  const c = categorieId || ''
  const cr = params.get('cr') || ''
  const cl = params.get('cl') || ''

  const hb = params.get('hb')
  const sh = params.get('sh')
  const fcp = params.get('fcp')

  const newQuery = {
    ...(b && { b }),
    ...(c && { c }),
    ...(cr && { cr }),
    ...(cl && { cl }),
    ...(hb && { hb }),
    ...(sh && { sh }),
    ...(fcp && { fcp }),
  }
  return newQuery
}
export default getCategoryFilterQuery
